import * as next from '../../../types/next'
import { getBlockNameByScope, type EnumButtonProps } from '../../../utils'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'

import { up as upBinaryInput } from './binaryControl'
import { nonEmptyStringOrUndefined, upCommonSettings } from './common'
import { up as upTextInput } from './textInputControl'

const getBlockMode = (options: Record<string, any>) => {
  if (options.button) return 'button'
  if (options.imageButton) return 'image'
  if (options.radio) return 'radio'

  return 'dropdown'
}

const upLayoutType = (
  buttonType: EnumButtonProps['buttonType']
): next.BUTTON_CHOICE_LAYOUT_TYPE => {
  switch (buttonType) {
    case 'row':
      return next.BUTTON_CHOICE_LAYOUT_TYPE.ROW

    case 'stack':
      return next.BUTTON_CHOICE_LAYOUT_TYPE.STACK

    case 'chip':
    default:
      return next.BUTTON_CHOICE_LAYOUT_TYPE.CHIP
  }
}

export const up: UpBlockHandler<
  next.SingleChoiceBlock | next.BinaryBlock | next.TextInputBlock
> = (uischema, schema, journey) => {
  if (uischema.type !== CONTROL_NAME.CONTROL) {
    throw new Error('Expected a valid Single Choice or Binary Input control')
  }

  const name = String(
    getBlockNameByScope(uischema.scope) ?? uischema.options?.title
  )

  // If the control is a binary input, we need to transform it to a binary block
  const schemaType = schema?.properties?.[name]?.type

  if (schemaType === 'boolean') {
    return upBinaryInput(uischema, schema, journey)
  }

  if (schemaType === 'string' && !schema?.properties?.[name]?.enum) {
    return upTextInput(uischema, schema, journey)
  }

  const options = uischema.options || {}
  const mode = getBlockMode(options)
  const buttonType = upLayoutType(options.buttonType)

  return {
    type: next.BLOCK_TYPE.SINGLE_CHOICE,
    settings: {
      ...upCommonSettings(uischema),
      mode,
      label: nonEmptyStringOrUndefined(options.label),
      options: options.buttonOptionsFileId
        ? { id: options.buttonOptionsFileId }
        : options.options,

      ...(options.optionsLabels && { labels: options.optionsLabels }),
      ...(options.optionsIcons && { icons: options.optionsIcons }),
      ...(mode === 'image' && {
        imageType: options.imageType,
        images: options.optionsImages
      }),
      ...(mode === 'button' && {
        buttonType
      })
    },
    references: {}
  }
}
